import { SITE_URL } from "@/constants/CEnv";

export type TLegalPage = "terms" | "privacy";

/** The site's paths, as Chronos-site/src/i18n/index.ts routes them. */
const PATHS: Record<TLegalPage, { fr: string; en: string }> = {
	terms: { fr: "/cgu", en: "/en/terms" },
	privacy: { fr: "/confidentialite", en: "/en/privacy" },
};

/**
 * Where a legal text lives on the site, in the visitor's language. Null
 * while no site URL is configured.
 */
export const legalUrl = (
	page: TLegalPage,
	language?: string
): string | null => {
	if (!SITE_URL) return null;
	const lang = (language ?? "fr").startsWith("fr") ? "fr" : "en";

	return `${SITE_URL}${PATHS[page][lang]}`;
};
